import { jsx as c, jsxs as y } from "react/jsx-runtime";
import { Flex as b } from "@chakra-ui/react";
import { flexRender as w } from "@tanstack/react-table";
import { useDrop as z, useDrag as I } from "react-dnd";
import { ArrowUpIcon as p, ArrowDownIcon as R } from "../../../icons/componentIcons.mjs";
import { Th as j } from "../Th/Th.mjs";
import { Td as T } from "../Td/Td.mjs";
const k = (o, r, n) => (n.splice(
  n.indexOf(r),
  0,
  n.splice(n.indexOf(o), 1)[0]
), [...n]), U = ({
  header: o,
  table: r,
  canReorderColumns: n,
  canSortColumns: l,
  enableMultiRowSelection: s
}) => {
  var u;
  const { getState: m, setColumnOrder: f } = r, { columnOrder: a } = m(), { column: e } = o, [, d] = z({
    accept: "column",
    drop: (t) => {
      const i = k(t.id, e.id, a);
      f(i);
    }
  }), [{ isDragging: S }, C, D] = I({
    collect: (t) => ({
      isDragging: t.isDragging()
    }),
    item: () => e,
    type: "column",
    canDrag: () => {
      var t;
      return n && (((t = o.column.columnDef.meta) == null ? void 0 : t.isReorderable) ?? !0);
    }
  }), { isNumeric: g } = o.column.columnDef.meta ?? {}, x = e.id === "select" && !s ? T : j;
  return /* @__PURE__ */ c(
    x,
    {
      ref: (t) => {
        d(t), C(t), D(t);
      },
      colSpan: o.colSpan,
      isNumeric: g,
      width: o.getSize() !== 0 ? `${o.getSize()}px` : void 0,
      opacity: S ? 0.5 : 1,
      ...e.id === "select" && !s && { backgroundColor: "gray.50" },
      children: o.isPlaceholder ? null : /* @__PURE__ */ y(
        b,
        {
          _hover: o.column.getIsSorted() ? {} : { svg: { opacity: 0.4 } },
          gap: 1,
          alignItems: "center",
          justifyContent: g ? "flex-end" : "flex-start",
          ...l && o.column.getCanSort() ? {
            cursor: "pointer",
            userSelect: "none",
            onClick: () => {
              const i = m().sorting.find((v) => v.id === e.id);
              i ? i.desc ? o.column.clearSorting() : o.column.toggleSorting(!0, o.column.getCanMultiSort()) : o.column.toggleSorting(!1, o.column.getCanMultiSort());
            }
          } : n && (((u = o.column.columnDef.meta) == null ? void 0 : u.isReorderable) ?? !0) ? { cursor: "grab", userSelect: "none" } : {},
          children: [
            w(o.column.columnDef.header, o.getContext()),
            (l && o.column.getCanSort() && {
              asc: /* @__PURE__ */ c(p, { size: "md", variant: "solid" }),
              desc: /* @__PURE__ */ c(R, { size: "md", variant: "solid" })
            }[o.column.getIsSorted()]) ?? /* @__PURE__ */ c(p, { size: "md", opacity: 0 })
          ]
        }
      )
    },
    o.id
  );
};
export {
  U as DraggableColumnHeader
};
